const CheckboxFlechaMenos = ({ color }) => {
  return (
    <svg
     className="CheckboxMinWidth"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="4" fill="#006299" />
      <path
        d="M5 9.42847H13"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CheckboxFlechaMenos;
